var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HPhero'),_c('HPintro'),_c('HPservices'),_c('HPtransactions_alt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }